module.exports = __webpack_public_path__ + "86cc8c0d4ca94bb2f99ffa77b4534f32.jpg";